import api from "../../../lib/api";

export default {
  postStar(data) {
    return api({
      endpoint: "stars",
      path: "starred",
      method: "POST",
      body: data
    });
  },
  deleteStar(data) {
    return api({
      endpoint: "stars",
      path: "starred",
      method: "DELETE",
      queryParams: data
    });
  },
  postDraftBookshelfThumbnailImages(data) {
    return api({
      endpoint: "draft-bookshelf-thumbnail-images",
      path: "walls",
      method: "POST",
      body: data
    });
  }
};
